import React from 'react';

import { routes, TYPES } from 'constants/config';
import { Icon } from 'ui';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';

const mapResponseToSuggestions = response => response.feedbackContributors;
const PotentialFeedbackContributor = ({ name, type }) => (
  <div className="d-f fz-16 py-4 ai-c">
    {type === TYPES.GROUP && (
      <Icon name="group" className="mr-8 c-brand-gray-dark" />
    )}
    <span className="d-f w-fill">{name}</span>
  </div>
);

const FeedbackContributorAutoComplete = ({
  identifier,
  scenarioId,
  selectedSuggestions,
  filterSuggestions,
  onSuggestionSelected,
  onSuggestionRemoved,
}) => {
  const url =
    routes.ON_DEMAND_PRACTICE.CREATOR.FEEDBACK_CONTRIBUTOR_OPTIONS.AUTOCOMPLETE_FEEDBACK_CONTRIBUTOR(
      scenarioId,
    );

  return (
    <>
      <RemoteAutoComplete
        url={url}
        queryParam="q"
        renderSuggestion={PotentialFeedbackContributor}
        getSuggestionValue={suggestion => suggestion.name}
        mapResponseToSuggestions={mapResponseToSuggestions}
        onSuggestionSelected={onSuggestionSelected}
        filterSuggestions={filterSuggestions}
        placeholder={t(
          'practice.on_demand_practice.editor.scenario_autocomplete_placeholder',
        )}
        className="ScenarioEditor-input w-fill mb-12"
      />
      <div className="d-f fw-w mb-16 mt-8">
        {selectedSuggestions.map(potentialFeedbackContributor => (
          <span
            key={identifier(potentialFeedbackContributor)}
            className="d-ib p-4-8 mr-8 mb-4 bg-gray-light bdrs-small c-black fw-b fz-12 f-smooth"
          >
            {potentialFeedbackContributor.name}
            <button
              type="button"
              aria-label={t('common.close')}
              onClick={onSuggestionRemoved(potentialFeedbackContributor)}
              className="u-resetBtn ml-8"
            >
              <Icon name="remove" />
            </button>
          </span>
        ))}
      </div>
    </>
  );
};

export default FeedbackContributorAutoComplete;
